import Vue from 'vue'
import Vuex from 'vuex'
import {conText} from './configText'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        loginStade:false,      //登录页按钮状态
        pageSize: 20,          //每页请求数量
        
        windowwidth: 0,        //浏览器的宽度
        windowHeight: 0,       //浏览器的高度
        topBlockHeight: 60,    //顶部块的高度 
        leftBlockWidth: 200,   //左侧块的宽度
        blockNavHeight: 40,    //页签的高度 
        indexPadding: 15,      //主体的边距
        tableEmpty:"数据空空",  //当表格数据为空的时候显示的文字
        tableSize:"small",    //正常(medium) 小(small) 超小(mini)
        routerNavWidth:200,    //路由页面左侧栏的宽度
        ResetrouterNavWidth:0, //动态重置路由页面的高度 
        inputSize:"small",     //正常(medium) 小(small) 超小(mini)
        popSize:null,          //正常(medium) 小(small) 超小(mini)
        selectSize:"medium",   //正常(medium) 小(small) 超小(mini)  
        btnSize:"small",       //正常(medium) 小(small) 超小(mini)
        emptyText:"",          //为空的支付提示只用用于单个
        operator:"",           //操作人 
        conText:conText,       //各种文件配置 
    },
    mutations: {
        //设置浏览器窗口的信息
        setWindowBtn(state,val) {
            state.windowwidth = val.clientWidth
            state.windowHeight = val.clientHeight
        },

        //动态设置路由页面左侧导航栏的宽度
        setResetrouterNavWidth(state,val){
            state.ResetrouterNavWidth = val.ResetrouterNavWidth
        },

        //登录页面loding
        setloginStade(state,val){
            state.loginStade = val.loginStade
        },

        //设置空字符串的提示
        setEmptyText(state,val){
            state.emptyText = val.emptyText
        },

        //设置当前操作人
        setOperator(state,val){
            state.operator = val.operator
        },
    }
})
export default store